import { StylableDOMUtil } from '@stylable/dom-test-kit';
import * as style from './Text.st.css';

export const textDriverFactory = ({ element, wrapper }) => {
  const stylableDOMUtil = new StylableDOMUtil(style);
  const wrapperSelector = wrapper
    ? (wrapper.querySelector || wrapper.find).bind(wrapper)
    : () => null;
  const ariaLabelElement = wrapperSelector('[data-sr-only="true"]') as Element;

  return {
    exists: () => !!element,
    getAttribute: (attrName) => element.getAttribute(attrName),
    /** Per a11y definitions, for text elements, aria-label should not be used with the text content but rather use a solution as described here: https://accessible360.com/accessible360-blog/use-aria-label-screen-reader-text/ */
    isAriaLabelElementExists: () => !!ariaLabelElement,
    /** The content of the SR only element containing the aria-label information */
    getAriaLabelContent: () => ariaLabelElement.textContent,
    getTagName: () => element.tagName.toLowerCase(),
    getContent: () => element.textContent,
    getTypography: () => stylableDOMUtil.getStyleState(element, 'typography'),
    getPriority: () => stylableDOMUtil.getStyleState(element, 'priority'),
    isMobile: () => element.hasAttribute('data-mobile'),
  };
};
